import * as React from 'react';
import {
    LOAN_APPLICATION_MX
} from '../../../../constants/LabelConstants';
import {
    FilesSectionProps,
    FilesSectionState,
} from '../../../../types/mx/turboCash/components';
import { FIELD_UPLOAD_REQUIRED } from '../../../../constants/ValidateConstant';
import FileUploader from '../../../../../common/components/FileUploader';
import * as FileTypeConstants from '../../../../../common/constants/FileTypeConstants';
import {
    DZ_ADMIN_FILE_UPLOADER_ACCEPTED_TYPES
} from '../../../../../common/constants/MimeTypeConstants';

class FilesSectionView extends React.Component<FilesSectionProps, FilesSectionState> {

    constructor(props) {
        super(props);

        this.state = {
            ifeFrontFilesError: this.props.ifeFrontFiles.length === 0 ?
                FIELD_UPLOAD_REQUIRED : null,
            ifeBackFilesError: this.props.ifeBackFiles.length === 0 ?
                FIELD_UPLOAD_REQUIRED : null,
            homeFilesError:  this.props.homeFiles.length === 0 ?
                FIELD_UPLOAD_REQUIRED : null,
            otherMonth1FilesError: this.props.otherMonth1Files.length === 0 ?
                FIELD_UPLOAD_REQUIRED : null,
            otherMonth2FilesError: this.props.otherMonth2Files.length === 0 ?
                FIELD_UPLOAD_REQUIRED : null,
            otherMonth3FilesError: this.props.otherMonth3Files.length === 0 ?
                FIELD_UPLOAD_REQUIRED : null,
            carLicenceFrontFilesError: this.props.carLicenceFrontFiles.length === 0 ?
                FIELD_UPLOAD_REQUIRED : null,
            carLicenceBackFilesError: this.props.carLicenceBackFiles.length === 0 ?
                FIELD_UPLOAD_REQUIRED : null
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.ifeFrontFiles.length !== this.props.ifeFrontFiles.length) {
            this.setState({
                ifeFrontFilesError:
                    this.props.ifeFrontFiles.length === 0 ? FIELD_UPLOAD_REQUIRED : null
            });
        } else if (prevProps.ifeBackFiles.length !== this.props.ifeBackFiles.length) {
            this.setState({
                ifeBackFilesError: this.props.ifeBackFiles.length === 0 ? FIELD_UPLOAD_REQUIRED : null
            });
        } else if (prevProps.homeFiles.length !== this.props.homeFiles.length) {
            this.setState({
                homeFilesError: this.props.homeFiles.length === 0 ? FIELD_UPLOAD_REQUIRED : null
            });
        } else if (prevProps.otherMonth1Files.length !== this.props.otherMonth1Files.length) {
            this.setState({
                otherMonth1FilesError:
                    this.props.otherMonth1Files.length === 0 ? FIELD_UPLOAD_REQUIRED : null
            });
        } else if (prevProps.otherMonth2Files.length !== this.props.otherMonth2Files.length) {
            this.setState({
                otherMonth2FilesError:
                    this.props.otherMonth2Files.length === 0 ? FIELD_UPLOAD_REQUIRED : null
            });
        } else if (prevProps.otherMonth3Files.length !== this.props.otherMonth3Files.length) {
            this.setState({
                otherMonth3FilesError:
                    this.props.otherMonth3Files.length === 0 ? FIELD_UPLOAD_REQUIRED : null
            });
        } else if (prevProps.carLicenceFrontFiles.length !== this.props.carLicenceFrontFiles.length) {
            this.setState({
                carLicenceFrontFilesError:
                    this.props.carLicenceFrontFiles.length === 0 ? FIELD_UPLOAD_REQUIRED : null
            });
        } else if (prevProps.carLicenceBackFiles.length !== this.props.carLicenceBackFiles.length) {
            this.setState({
                carLicenceBackFilesError:
                    this.props.carLicenceBackFiles.length === 0 ? FIELD_UPLOAD_REQUIRED : null
            });
        }
    }

    onDropIdentificationFiles = (accepted, type, section, error) => {
        this.setState({
            ifeFrontFilesError:
                section === FileTypeConstants.IFE_FRONT_SECTION ? error : this.state.ifeFrontFilesError,
            ifeBackFilesError:
                section === FileTypeConstants.IFE_BACK_SECTION ? error : this.state.ifeBackFilesError
        });
        this.props.onDropIdentificationFiles(accepted, type, section, error);
    }

    onDropCarLicenceFiles = (accepted, type, section, error) => {
        this.setState({
            carLicenceFrontFilesError:
                section === FileTypeConstants.DRIVER_LICENSE_FRONT_SECTION ?
                    error : this.state.carLicenceFrontFilesError,
            carLicenceBackFilesError:
                section === FileTypeConstants.DRIVER_LICENSE_BACK_SECTION ?
                    error : this.state.carLicenceBackFilesError
        });
        this.props.onDropCarLicenceFiles(accepted, type, section, error);
    }

    onDropHomeFiles = (accepted, type, section, error) => {
        this.setState({homeFilesError: error});
        this.props.onDropHomeFiles(accepted, type, section, error);
    }

    onDropOtherFiles = (accepted, type, section, error) => {
        this.setState({
            otherMonth1FilesError:
                section === FileTypeConstants.INCOMES_FIRST_SECTION ? error : this.state.otherMonth1FilesError,
            otherMonth2FilesError:
                section === FileTypeConstants.INCOMES_SECOND_SECTION ? error : this.state.otherMonth2FilesError,
            otherMonth3FilesError:
                section === FileTypeConstants.INCOMES_THIRD_SECTION ? error : this.state.otherMonth3FilesError
        });
        this.props.onDropOtherFiles(accepted, type, section, error);
    }

    render() {
        return (
            <React.Fragment>
                <div className="row mb-4 mt-4">
                    <div className="col">
                        <h3>{LOAN_APPLICATION_MX.FILE_UPLOAD_IDENTIFICATION}</h3>
                    </div>
                </div>
                <div className="row justify-content-start">
                    <div className="col-md-3 col-lg-2">
                        <FileUploader
                            id="ifeFront"
                            type={FileTypeConstants.IDENTIFICATION_TYPE}
                            section={FileTypeConstants.IFE_FRONT_SECTION}
                            accept={DZ_ADMIN_FILE_UPLOADER_ACCEPTED_TYPES}
                            multiple={false}
                            label={LOAN_APPLICATION_MX.FILE_UPLOAD_BOX_FRONT}
                            onDrop={this.onDropIdentificationFiles}
                            onDelete={this.props.onDeleteIdentificationFile}
                            onClickThumbnail={this.props.onClickThumbnail}
                            uploadedFiles={this.props.ifeFrontFiles}
                            hasError={this.props.showErrors}
                            labelError={this.state.ifeFrontFilesError}/>
                    </div>

                    <div className="col-md-3 col-lg-2">
                        <FileUploader
                            id="ifeBack"
                            type={FileTypeConstants.IDENTIFICATION_TYPE}
                            section={FileTypeConstants.IFE_BACK_SECTION}
                            accept={DZ_ADMIN_FILE_UPLOADER_ACCEPTED_TYPES}
                            multiple={false}
                            label={LOAN_APPLICATION_MX.FILE_UPLOAD_BOX_BACK}
                            onDrop={this.onDropIdentificationFiles}
                            onDelete={this.props.onDeleteIdentificationFile}
                            onClickThumbnail={this.props.onClickThumbnail}
                            uploadedFiles={this.props.ifeBackFiles}
                            hasError={this.props.showErrors}
                            labelError={this.state.ifeBackFilesError}/>
                    </div>
                </div>
                <div className="row mb-4 mt-4">
                    <div className="col">
                        <h3>{LOAN_APPLICATION_MX.FILE_UPLOAD_HOME}</h3>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3 col-lg-2">
                        <FileUploader
                            id="homeFiles"
                            accept={DZ_ADMIN_FILE_UPLOADER_ACCEPTED_TYPES}
                            type={FileTypeConstants.HOME_TYPE}
                            section={FileTypeConstants.HOME_SECTION}
                            label={LOAN_APPLICATION_MX.FILE_UPLOAD_HOME_BOX}
                            multiple={false}
                            onDrop={this.onDropHomeFiles}
                            onDelete={this.props.onDeleteHomeFile}
                            onClickThumbnail={this.props.onClickThumbnail}
                            uploadedFiles={this.props.homeFiles}
                            hasError={this.props.showErrors}
                            labelError={this.state.homeFilesError}/>
                    </div>
                </div>
                <div className="row mb-4 mt-4">
                    <div className="col">
                        <h3>{LOAN_APPLICATION_MX.FILE_UPLOAD_OTHER}</h3>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3 col-lg-2">
                        <FileUploader
                            id="otherFiles-1"
                            accept={DZ_ADMIN_FILE_UPLOADER_ACCEPTED_TYPES}
                            type={FileTypeConstants.OTHER_TYPE}
                            section={FileTypeConstants.INCOMES_FIRST_SECTION}
                            multiple={false}
                            label={LOAN_APPLICATION_MX.FILE_UPLOAD_OTHER_BOX_1}
                            onDrop={this.onDropOtherFiles}
                            onDelete={this.props.onDeleteOtherFile}
                            uploadedFiles={this.props.otherMonth1Files}
                            onClickThumbnail={this.props.onClickThumbnail}
                            hasError={this.props.showErrors}
                            labelError={this.state.otherMonth1FilesError}/>
                    </div>
                    <div className="col-md-3 col-lg-2">
                        <FileUploader
                            id="otherFiles-2"
                            accept={DZ_ADMIN_FILE_UPLOADER_ACCEPTED_TYPES}
                            type={FileTypeConstants.OTHER_TYPE}
                            section={FileTypeConstants.INCOMES_SECOND_SECTION}
                            multiple={false}
                            label={LOAN_APPLICATION_MX.FILE_UPLOAD_OTHER_BOX_2}
                            onDrop={this.onDropOtherFiles}
                            onDelete={this.props.onDeleteOtherFile}
                            uploadedFiles={this.props.otherMonth2Files}
                            onClickThumbnail={this.props.onClickThumbnail}
                            hasError={this.props.showErrors}
                            labelError={this.state.otherMonth2FilesError}/>
                    </div>
                    <div className="col-md-3 col-lg-2">
                        <FileUploader
                            id="otherFiles-3"
                            accept={DZ_ADMIN_FILE_UPLOADER_ACCEPTED_TYPES}
                            type={FileTypeConstants.OTHER_TYPE}
                            section={FileTypeConstants.INCOMES_THIRD_SECTION}
                            multiple={false}
                            label={LOAN_APPLICATION_MX.FILE_UPLOAD_OTHER_BOX_3}
                            onDrop={this.onDropOtherFiles}
                            onDelete={this.props.onDeleteOtherFile}
                            uploadedFiles={this.props.otherMonth3Files}
                            onClickThumbnail={this.props.onClickThumbnail}
                            hasError={this.props.showErrors}
                            labelError={this.state.otherMonth3FilesError}/>
                    </div>
                </div>
                <div className="row mb-4 mt-4">
                    <div className="col">
                        <h3>{LOAN_APPLICATION_MX.FILE_UPLOAD_DRIVER_LICENSE}</h3>
                    </div>
                </div>
                <div className="row justify-content-start">
                    <div className="col-md-3 col-lg-2">
                        <FileUploader
                            id="carLicenceFront"
                            type={FileTypeConstants.DRIVER_LICENSE_TYPE}
                            section={FileTypeConstants.DRIVER_LICENSE_FRONT_SECTION}
                            accept={DZ_ADMIN_FILE_UPLOADER_ACCEPTED_TYPES}
                            multiple={false}
                            label={LOAN_APPLICATION_MX.FILE_UPLOAD_FRONT}
                            onDrop={this.onDropCarLicenceFiles}
                            onDelete={this.props.onDeleteCarLicenceFile}
                            onClickThumbnail={this.props.onClickThumbnail}
                            uploadedFiles={this.props.carLicenceFrontFiles}
                            hasError={this.props.showErrors}
                            labelError={this.state.carLicenceFrontFilesError}/>
                    </div>

                    <div className="col-md-3 col-lg-2">
                        <FileUploader
                            id="carLicenceBack"
                            type={FileTypeConstants.DRIVER_LICENSE_TYPE}
                            section={FileTypeConstants.DRIVER_LICENSE_BACK_SECTION}
                            accept={DZ_ADMIN_FILE_UPLOADER_ACCEPTED_TYPES}
                            multiple={false}
                            label={LOAN_APPLICATION_MX.FILE_UPLOAD_BACK}
                            onDrop={this.onDropCarLicenceFiles}
                            onDelete={this.props.onDeleteCarLicenceFile}
                            onClickThumbnail={this.props.onClickThumbnail}
                            uploadedFiles={this.props.carLicenceBackFiles}
                            hasError={this.props.showErrors}
                            labelError={this.state.carLicenceBackFilesError}/>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default FilesSectionView;
